export default {
  serverBaseUrl: process.env.VUE_APP_BASE_URL,
  ApiBaseUrl: process.env.VUE_APP_API_URL,
  ApiBaseUrlV2: process.env.VUE_APP_API_URL_V2,
  debtiaappUrl: process.env.VUE_APP_DEBTIAAPP_API_URL,
}
